export const AppPermTypeEnum = {
  READ: 'read',
  WRITE: 'write',
};

export const PermissionList = {
  ADMIN_ACCESS_READ: 'ADMIN_ACCESS_READ',
  ADMIN_ACCESS_WRITE: 'ADMIN_ACCESS_WRITE',
  PHOENIX_READ: 'PHOENIX_READ',
};
